import React from 'react';
import styles from './style.module.css';
import IframeResize from "../../../../common/components/iframe-resize";

export default () => (
    <div className={styles.page}>
        <h1 className={'invisible'}>TFSA vs Taxable Investment Calculator</h1>
        <iframe src="https://www.financialcalculators.net/librocu/tfsa-taxable/" title="TFSA vs Taxable Investment Calculator" scrolling="no" frameBorder="0"> </iframe>
            <IframeResize />
    </div>
);
